import { ApolloLink } from '@apollo/client'

let handleSessionExpired: (() => void) | null = null

/** Sets what runs when the gateway reports that the sign-in is gone. */
export const setSessionExpiredHandler = (handler: (() => void) | null) => {
  handleSessionExpired = handler
}

/**
 * The gateway flags a response with `extensions.sessionExpired` when it
 * rejected the refresh token and cleared the session cookies. Public
 * operations still succeed anonymously, so without the flag the app would
 * only notice on the first operation that needs a user.
 */
export const sessionExpiredLink = new ApolloLink((operation, forward) =>
  forward(operation).map(result => {
    if (result.extensions?.sessionExpired) handleSessionExpired?.()
    return result
  })
)
